<script setup lang="ts">
import type { AccordionItemDefault } from '#imports';

defineProps<{
  accordionItem: AccordionItemDefault;
}>();
</script>

<template>
  <BaseRte
    v-if="accordionItem.content?.text"
    :content="accordionItem.content.text"
    class="px-2"
  />
</template>
